module.exports = __webpack_public_path__ + "38fa681661e416c4ba379795d03c2bb2.svg";